import * as React from 'react';
import { flow, get, forEach } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, Form, FormGroup, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, IProduct, QuoteStatus} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import Vehicles from './components/Vehicles';
import VehiclesQuote from '../Quote/components/Vehicles';
import FieldFormControl from '../../../../components/FieldFormControl';
import FaCheck from 'react-icons/fa/check';
import {isRequired} from '../../../../util/validators';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getReferralsAndDeclines} from '../../../../util/helpers';
import Slider from '../../../../components/Slider';
import {isUndefined} from 'util';

interface IVehiclesFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };
  vehicleCount: number;
  voluntaryExcessEnabled: string;
  voluntaryExcess: string;
  vehicles: any;
}

class VehiclesForm extends React.Component<IVehiclesFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    referred: false,
    duplicateRegistration: -1,
  };

  public componentWillReceiveProps(nextProps) {
    const { quote, actions, vehicles } = this.props;

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.referrals !== referralsAndDeclines.referrals) {
      this.setState({referrals: referralsAndDeclines.referrals});
      if (!referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({referred: true});
        setTimeout((() => {
          actions.quote.referralQuote(quote.application.id, referralsAndDeclines.referrals);
        }), 2000);
      }
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }

    if (vehicles !== nextProps.vehicles) {
      const registrationList = [];
      this.setState({duplicateRegistration: -1});
      forEach(nextProps.vehicles, (vehicle, index) => {
        if (vehicle.registrationNumber && registrationList.includes(vehicle.registrationNumber)) {
          this.setState({duplicateRegistration: index});
        }
        registrationList.push(vehicle.registrationNumber);
      });
    }
  }

  private checkVehicles(vehicles) {
    if (isUndefined(vehicles)) {
      return false;
    }

    return vehicles.reduce((carry, vehicle) => {
      return carry && vehicle.bodyType && vehicle.year && vehicle.value;
    }, true);
  }

  private checkVehiclesInfo(vehicles) {
    if (isUndefined(vehicles)) {
      return false;
    }

    return vehicles.reduce((carry, vehicle) => {
      return carry && vehicle.model;
    }, true);
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
          channel={this.props.channel}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/proposer'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private bodyTypes() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.body_types.agricultural', {});

    const excludedTypes = [
      'Combine Harvester',
      'Bulldozer',
      'Crane',
      'Forest Harvester',
      'Other Harvester',
      'Potato / Beet Harvester',
      'Viner',
    ];

    return Object.keys(types).filter((type) => {
      return !excludedTypes.includes(type);
    }).map((type) => {
      return { label: type, value: type };
    });
  }

  private bodyTypeRules() {
    const { quote } = this.props;
    return get(quote, 'quotes.standard.annual.scheme.metadata.body_types.agricultural', {});
  }

  private handleSlider = (event) => {
    const {change, dispatch} = this.props;
    if (event.length > 0) {
      let result = event[0];
      if (result > 500 && result < 750) {
        result = 750;
      } else if (result > 750 && result < 1000) {
        result = 1000;
      }
      dispatch(change('voluntaryExcess', result.toString()));
    }
  }

  private checkSliderJumps(percent) {
    if (percent > 50 && percent < 75) {
      percent = 75;
    } else if (percent > 75 && percent < 100) {
      percent = 100;
    }

    return [ percent, percent * 10 ];
  }

  private noVoluntaryAccess = () => {
    const { dispatch, change } = this.props;

    dispatch(change('voluntaryExcess', '0'));
  }

  public render() {
    const {
      handleSubmit,
      vehicleCount,
      voluntaryExcessEnabled,
      dispatch,
      change,
      quote,
      vehicles,
      voluntaryExcess,
      renderDefinition,
    } = this.props;
    const { duplicateRegistration } = this.state;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const hasBackButton = quote.application.status !== QuoteStatus.REFERRAL_APPROVED;

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            <FieldArray
              name="vehicles"
              component={Vehicles}
              count={vehicleCount}
              bodyTypes={this.bodyTypes()}
              bodyTypeRules={this.bodyTypeRules()}
              dispatch={dispatch}
              change={change}
              renderDefinition={renderDefinition}
            />
           <div className="quick-vehicle-body-2">
             {this.checkVehicles(vehicles) && (
                <hr className="hr-brown" />
             )}
           </div>
            {this.checkVehicles(vehicles) && (
              <div>
                <h3>Vehicle Information</h3>
                <FieldArray
                  name="vehicles"
                  component={VehiclesQuote}
                  count={vehicleCount}
                  dispatch={dispatch}
                  change={change}
                  renderDefinition={renderDefinition}
                  duplicateRegistration={duplicateRegistration}
                />
              </div>
            )}
            <div className="quick-vehicle-body-2">
              {this.checkVehiclesInfo(vehicles) && (
                <hr className="hr-brown" />
              )}
            </div>
             {this.checkVehiclesInfo(vehicles) && (
               <Row>
                 <Col sm={12}>
                   <h3>Excess</h3>
                 </Col>
               </Row>
             )}
             <div className="vehicle-box">
              <div className="quick-vehicle-body">
                 {this.checkVehiclesInfo(vehicles) && (
                   <Col sm={2}>
                     <div className="quick-excess-icon">
                       <img src={require('../../img/excess.svg')} alt="" />
                     </div>
                   </Col>
                 )}
                 {this.checkVehiclesInfo(vehicles) && (
                   <Col sm={10} className="excess-padding-left">
                      <Row>
                        <Col sm={6} className="vehicle-questions vehicle-info-centre">
                          {renderDefinition('b2c_vehicle_voluntary_excess')}
                          Would you like to add a voluntary excess?
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="voluntary_excess_show">
                            <Row className="button-group-container">
                              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                                <Field
                                  name="voluntaryExcessEnabled"
                                  type="radio"
                                  value="false"
                                  component={FieldFormControl}
                                  validate={[ isRequired ]}
                                  onClick={this.noVoluntaryAccess}
                                >
                                  <div className={'button-group-btn'}>
                                    No
                                    <FaCheck/>
                                  </div>
                                </Field>
                              </Col>
                              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                                <Field
                                  name="voluntaryExcessEnabled"
                                  type="radio"
                                  value="true"
                                  component={FieldFormControl}
                                  validate={[ isRequired ]}
                                >
                                  <div className={'button-group-btn'}>
                                    Yes
                                    <FaCheck/>
                                  </div>
                                </Field>
                              </Col>
                            </Row>
                          </FormGroup>
                        </Col>
                      </Row>
                      {voluntaryExcessEnabled === 'true' && (
                        <FormGroup controlId={'voluntary_excess'}>
                          <Col className="vehicle-questions" sm={8}>
                            Please select Voluntary excess amount:
                          </Col>
                          <Col sm={4}>
                            <div className="full-name-fields">
                              <Row>
                                <Col sm={12}/>
                              </Row>
                            </div>
                          </Col>
                          <Row>
                            <Col sm={12} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                              <Slider
                                tickValues={[0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 750, 1000]}
                                jumpPercents={this.checkSliderJumps}
                                handleColor="#5B2D2B"
                                trackColor="#403F3F"
                                onChange={this.handleSlider}
                                value={voluntaryExcess ? voluntaryExcess : 0}
                              />
                            </Col>
                          </Row>
                        </FormGroup>
                      )}
                 </Col>
               )}
            </div>
             </div>
          </div>
          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/proposer'}
            {...this.props}
            nextButtonDisabled={duplicateRegistration > -1}
            hasSaveButton={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const vehicleCount = selector(state, 'vehicleCount');
      const vehicles = selector(state, 'vehicles');
      const voluntaryExcessEnabled = selector(state, 'voluntaryExcessEnabled');
      const voluntaryExcess = selector(state, 'voluntaryExcess');

      return {
        startDate,
        quotationTypes,
        vehicleCount,
        vehicles,
        voluntaryExcessEnabled,
        voluntaryExcess,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(VehiclesForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/index.tsx